import React from 'react';

export type CardProps = {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
};

export default function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div
      className={`w-[263px] h-[167px] shadow-3xl bg-white hover:v2-bg-yellow-50 cursor-pointer rounded ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
